// src/pages/PlanosAssinatura.jsx
import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useNavigate } from "react-router-dom";
import { app } from "../firebase"; // ajuste o caminho conforme seu projeto
;

// Garanta que a região bate com a das Functions (us-central1)
const functions = getFunctions(app, "us-central1");
const auth = getAuth(app);

const planos = [
    {
        id: "single",
        titulo: "Single",
        precoLabel: "R$ 64,90/mês",
        bullets: ["Agendamentos básicos", "1 colaborador", "Suporte por WhatsApp"],
    },
    {
        id: "pro",
        titulo: "Pro",
        precoLabel: "R$ 94,90/mês",
        bullets: ["Agendamentos avançados", "Até 5 colaboradores", "Suporte por WhatsApp"],
    },
    {
        id: "enterprise",
        titulo: "Enterprise",
        precoLabel: "R$ 149,90/mês",
        bullets: ["Recursos completos", "Equipe ilimitada", "Suporte prioritário"],
    },
];

export default function PlanosAssinatura() {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loadingPlanId, setLoadingPlanId] = useState(null);
    const [erro, setErro] = useState("");

    useEffect(() => {
        const unsub = onAuthStateChanged(auth, (u) => setUser(u || null));
        return () => unsub();
    }, []);

    const handleAssinar = async (planId) => {
        setErro("");
        if (!user) {
            setErro("Você precisa entrar para assinar.");
            return;
        }

        // abre a nova guia *no gesto do usuário*
        const newTab = window.open("about:blank", "_blank"); // mantém referência
        try {
            setLoadingPlanId(planId);
            const createStripePaymentLink = httpsCallable(functions, "createStripePaymentLink");
            const { data } = await createStripePaymentLink({ planId });

            if (data?.url) {
                // segurança contra reverse tabnabbing
                if (newTab) newTab.opener = null;
                newTab.location = data.url; // redireciona a nova guia
            } else {
                if (newTab) newTab.close();
                throw new Error("Não foi possível obter o link de pagamento.");
            }
        } catch (e) {
            if (newTab) newTab.close(); // fecha a guia em branco se der erro
            console.error(e);
            setErro(e?.message || "Falha ao iniciar o pagamento. Tente novamente.");
        } finally {
            setLoadingPlanId(null);
        }
    };


    return (
        <>
            <div style={styles.page}>
                <h1 style={styles.title}>Escolha seu plano</h1>
                {!user && (
                    <div style={styles.alert}>
                        <p>Você precisa estar logado para continuar a assinatura.</p>
                        <button style={styles.loginBtn} onClick={() => navigate("/login")}>
                            Entrar
                        </button>
                    </div>
                )}
                {erro && <div style={styles.error}>{erro}</div>}
                <div style={styles.grid}>
                    {planos.map((p) => (
                        <div key={p.id} style={styles.card}>
                            <h2 style={styles.cardTitle}>{p.titulo}</h2>
                            <p style={styles.price}>{p.precoLabel}</p>
                            <ul style={styles.list}>
                                {p.bullets.map((b, i) => (
                                    <li key={i} style={styles.listItem}>
                                        {b}
                                    </li>
                                ))}
                            </ul>
                            <button
                                style={{
                                    ...styles.cta,
                                    ...(loadingPlanId === p.id ? styles.ctaLoading : {}),
                                    ...(user ? {} : styles.ctaDisabled),
                                }}
                                onClick={() => handleAssinar(p.id.toString().trim().toLowerCase())}
                                disabled={!user || loadingPlanId === p.id}
                            >
                                {loadingPlanId === p.id ? "Gerando link..." : "Assinar"}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        padding: "40px 20px",
        background: "linear-gradient(180deg, #f6f9fe 0%, #fff 100%)",
        fontFamily: "Poppins, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, 'Helvetica Neue', Arial",
        color: "#1F1A1A",
    },
    title: {
        textAlign: "center",
        fontSize: 32,
        fontWeight: 700,
        marginBottom: 24,
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 20,
        maxWidth: 1000,
        margin: "0 auto",
    },
    card: {
        background: "#fff",
        border: "1px solid #e6ecf5",
        borderRadius: 16,
        padding: 20,
        boxShadow: "0 6px 20px rgba(58,121,237,0.08)",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
    },
    cardTitle: { fontSize: 22, fontWeight: 700, marginBottom: 8 },
    price: { fontSize: 18, fontWeight: 600, marginBottom: 12, color: "#3a79ed" },
    list: { listStyle: "none", padding: 0, margin: "0 0 16px 0" },
    listItem: { marginBottom: 6 },
    cta: {
        marginTop: "auto",
        border: "none",
        borderRadius: 12,
        padding: "12px 16px",
        fontWeight: 700,
        fontSize: 16,
        background: "#3a79ed",
        color: "#fff",
        cursor: "pointer",
        transition: "transform .06s ease, opacity .2s ease",
    },
    ctaLoading: { opacity: 0.7, cursor: "wait" },
    ctaDisabled: { opacity: 0.5, cursor: "not-allowed" },
    alert: {
        maxWidth: 1000,
        margin: "0 auto 16px",
        background: "#fff7e6",
        border: "1px solid #ffe0a3",
        color: "#8a6d3b",
        borderRadius: 12,
        padding: 12,
        display: "flex",
        alignItems: "center",
        gap: 12,
        justifyContent: "space-between",
    },
    loginBtn: {
        border: "1px solid #3a79ed",
        background: "#fff",
        color: "#3A79ED",
        borderRadius: 10,
        padding: "8px 12px",
        fontWeight: 600,
        cursor: "pointer",
    },
    error: {
        maxWidth: 1000,
        margin: "0 auto 16px",
        background: "#ffe6e6",
        border: "1px solid #ffb3b3",
        color: "#7a1f1f",
        borderRadius: 12,
        padding: 12,
    },
};
